import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { normalConfig } from "./data";

export default function NormalPage() {
  return <CityPageTemplate config={normalConfig} />;
}